"use strict";
const { object, number } = require('../utils/modifiedYup');
const { errors } = require('../../constants');
const yup = require('../utils/modifiedYup');
const MILLISECONDS_PER_MILLISECOND = 1;
const MILLISECONDS_PER_SECOND = 1000 * MILLISECONDS_PER_MILLISECOND;
const MILLISECONDS_PER_MINUTE = 60 * MILLISECONDS_PER_SECOND;
const MILLISECONDS_PER_HOUR = 60 * MILLISECONDS_PER_MINUTE;
const MILLISECONDS_PER_DAY = 24 * MILLISECONDS_PER_HOUR;
// yup.addMethod is a helper function which modifies the given object prototype
// to add the minimumDuration method
yup.addMethod(object, 'minimumDuration', function validate(minimumDurationMilliseconds = 0) {
    return this.test({
        name: 'minimumDuration',
        // Dynamically set the error message based on the given duration
        message: errors.minimumDurationSelection({
            minimumDurationMinutes: minimumDurationMilliseconds / MILLISECONDS_PER_MINUTE,
        }),
        test({ days = 0, hours = 0, minutes = 0, 
        // For testing purposes we can specify these
        seconds = 0, milliseconds = 0, } = {}) {
            const totalMilliseconds = days * MILLISECONDS_PER_DAY +
                hours * MILLISECONDS_PER_HOUR +
                minutes * MILLISECONDS_PER_MINUTE +
                seconds * MILLISECONDS_PER_SECOND +
                milliseconds * MILLISECONDS_PER_MILLISECOND;
            if (totalMilliseconds < minimumDurationMilliseconds) {
                return this.createError();
            }
            return true;
        },
    });
});
const durationSchema = object().shape({
    days: number().positive().integer().min(0).max(99).required(),
    hours: number().positive().integer().min(0).max(23).required(),
    minutes: number().positive().integer().min(0).max(59).required(),
    seconds: number().positive().integer().min(0),
    milliseconds: number().positive().integer().min(0),
});
module.exports = {
    durationSchema,
    MILLISECONDS_PER_MILLISECOND,
    MILLISECONDS_PER_SECOND,
    MILLISECONDS_PER_MINUTE,
    MILLISECONDS_PER_HOUR,
    MILLISECONDS_PER_DAY,
};
//# sourceMappingURL=durationSchema.js.map